import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { getUrl, showError } from '@utils';
import { useRouter } from 'next/router';
import { QUERY_KEYS } from 'constants/queryKeys';
import { URLS } from 'layouts/DrawerLayout/constants';
import { videosServices } from '@services';
import { normalizeVideos } from './utils';

export const VIDEOS_PAGE_SIZE = 50;

export const useVideosOperations = () => {
  const router = useRouter();
  const page = router.query?.page || '1';

  const videosResponse = useQuery([QUERY_KEYS.GET_VIDEOS_KEY, page], () =>
    videosServices.getVideos({ pageSize: VIDEOS_PAGE_SIZE, page })
  );

  const handlePageChange = (_event, newPage) => {
    const url = getUrl({ ...router.query, page: newPage }, URLS.videos);

    router.push(url);
  };

  useEffect(() => {
    if (videosResponse.error) {
      showError(videosResponse.error);
    }
  }, [videosResponse.error]);

  const videos = normalizeVideos(videosResponse?.data?.data || []);

  return {
    loading: videosResponse?.isLoading,
    videos,
    page,
    total: videosResponse?.data?.meta?.total || 0,
    pageSize: VIDEOS_PAGE_SIZE,
    getVideos: videosResponse.refetch,
    handlePageChange,
  };
};
